import { useContext, useEffect, useRef, useState } from 'react';
import { FormUtility } from '../../../Utility/FormUtility';
import Input from '../../../Form/Input';
import Select from '../../../Form/Select';
import { useNavigate, useParams } from 'react-router-dom';
import { Fase } from '../../../../models/Fase';
import { FaseService } from '../../../../services/FaseService';
import { BandoService } from '../../../../services/BandoService';
import DatePicker from '../../../Form/DatePicker';
import { tipologieFase } from '../../../../constants/TipologiaFase';
import ToastContext from '../../../../contexts/toast';
import StatusContext from '../../../../contexts/status';
import moment from 'moment';

export default function GestioneFase() {
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState([]);

  const [bandi, setBandi] = useState(null);

  const [tipologie, setTipologie] = useState(null);
  const [bandoFasiPresentazioneDomande, setBandoFasiPresentazioneDomande] = useState([]);
  const [fasiPresentazioneDomande, setFasiPresentazioneDomande] = useState([]);

  const [fase, setFase] = useState(new Fase());
  const [associablePresentazioneDomande, setAssociablePresentazioneDomande] =
    useState(false);

  const [mapDate, setMapDate] = useState(new Map());

  const bandoService = new BandoService();
  const faseService = new FaseService();

  const utility = new FormUtility();

  const allTipologie = utility.getAllTipologie();

  const params = useParams();
  const navigation = useNavigate();
  const formRef = useRef(null);

  const tipologiePresentazione = [tipologieFase.presentazione_domande, tipologieFase.riapertura_presentazione];

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const paramId = params.id;
  const now = moment().format('YYYY-MM-DDTHH:mm');

  useEffect(() => {
    bandoService.getAll().then((resp) => {
      setBandi(resp);
    });

    if (paramId) {
      faseService
        .getById(paramId)
        .then((resp) => {
          setFase(resp);
          completeMapDate(resp);
          setAssociablePresentazioneDomande(
            [
              tipologieFase.istruttoria,
              tipologieFase.secondo_accesso_non_ammessi_sospesi,
              tipologieFase.terzo_accesso_sospesi,
              tipologieFase.aggiornamento_isee,
              tipologieFase.annullamento_domande
            ].includes(resp.tipologia)
          );
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      completeMapDate(fase);
    }

    return () => {
      statusContext.removeEvent('onbeforeunload');
    };
  }, []);

  useEffect(() => {
    if (bandi && fase.id) {
      const bando = bandi.find((b) => b.id === fase.bando.id);
      setFasiPresentazioneDomande(
        bando.fasi.filter(
          (f) => tipologiePresentazione.includes(f.tipologia) &&
                    (f.id === fase.raccoltaDomande?.id || f.fasiAssociate.length === 0)
        )
      );
      setTipologie(allTipologie);
    }

    if (validate) {
      setFormErrors(false);
    }
  }, [bandi, fase]);

  const completeMapDate = (fase) => {
    const map = new Map([
      [
        'dataInizio',
        fase.dataInizio ? moment(fase.dataInizio).format('YYYY-MM-DD HH:mm') : now,
      ],
      [
        'dataFine',
        fase.dataFine ? moment(fase.dataFine).format('YYYY-MM-DD HH:mm') : now,
      ],
    ]);
    setMapDate(map);
  };

  const onChangeBando = (event) => {
    const value = event.target.value;
    const bando = value ? bandi.find((b) => b.id === parseInt(value)) : null;
    setTipologie(allTipologie);
    setBandoFasiPresentazioneDomande(
      bando?.fasi.filter(
        (fase) =>
          tipologiePresentazione.includes(fase.tipologia)
      )
    );

    setAssociablePresentazioneDomande(false);

    setFase(new Fase(fase.id, fase.titolo, value, value, null));
    statusContext.addEvent('onbeforeunload');
  };

  const updateMapDate = (event) => {
    onChangeValue(event);

    const field = event.target.name;
    const value = event.target.value;
    mapDate.set(field, moment(value).format('YYYY-MM-DD HH:mm'));
    setMapDate(new Map(mapDate));

    statusContext.addEvent('onbeforeunload');
  }; 

	const checkValidaDateError = (field, preValues, postValues, otherValues = []) => {
		const currVal = fase[field];
		if (validate && !currVal) {
			return 'Campo obbligatorio';
		}

		for (const val of preValues) {
			const valToCheck = fase[val] ?? val;
      const check = checkErrorDateTime(currVal, valToCheck);
      if (check) { return check; }
		}

		for (const val of postValues) {
			const valToCheck = fase[val];
			if (valToCheck < currVal) {
				return 'Inserire una data non oltre al ' + moment(valToCheck).format('DD/MM/YYYY');
			}
		}

		for (const val of otherValues) {
			if (val > currVal) {
				return 'Inserire una data almeno uguale al ' + moment(val).format('DD/MM/YYYY');
			}
		}

		return '';
	}

  const checkErrorDateTime = (value, valueRef) => {
    const valueDate = moment(value, 'YYYY-MM-DD');
    const valueRefDate = moment(valueRef, 'YYYY-MM-DD');

		if (!valueDate) {
			return 'Campo obbligatorio';
		}

		const timeStart = value ? value.split('T')[1] : null;
		const timeEnd = valueRef ? moment(valueRef, 'YYYY-MM-DDTHH:mm:ss.sssZ').format('HH:mm') : null;

    const ret = valueDate.isBefore(valueRefDate)
										? 'Inserire una data almeno uguale al ' + moment(new Date(valueRefDate), 'YYYY-MM-DD').format('DD/MM/YYYY')
										: valueDate.isSame(valueRefDate)
												? timeEnd < timeStart
														? 'Inserire un\'orario almeno uguale a ' + moment(new Date(valueRef), 'HH:mm').format('HH:mm')
														: ''
												: '';
		return ret;
  }

  const onChangeTipologia = (event) => {
    const value = event.target.value;
    setFase(new Fase(fase.id, fase.titolo, fase.bando, fase.bando_id, value));

    setAssociablePresentazioneDomande(
      [
        tipologieFase.istruttoria,
        tipologieFase.secondo_accesso_non_ammessi_sospesi,
        tipologieFase.terzo_accesso_sospesi,
        tipologieFase.aggiornamento_isee,
        tipologieFase.annullamento_domande
      ].includes(value)
    );
    setFasiPresentazioneDomande(
      bandoFasiPresentazioneDomande.filter(
        (fase) =>
          !fase.fasiAssociate.find(f => f.tipologia === value) 
      )
    );

    if (validate) {
      setFormErrors(false);
    }
  };

  const onChangeValue = async (event) => {
    const target = event.target;
    fase[target.name] = target.value;
    setFase({ ...fase });
    statusContext.addEvent('onbeforeunload');
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const denyOperation = () => {
    navigation(`/gestione-fasi`);
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    setInputErrors([]);

    fase.bando = fase.bando_id
      ? bandi.find((b) => b.id === parseInt(fase.bando_id))
      : fase.bando;
    fase.raccoltaDomande = fasiPresentazioneDomande.find(
      (f) => f.id === parseInt(fase.raccoltaDomande?.id || fase.raccoltaDomande)
    );

    const service = paramId ? faseService.update : faseService.create;
    service(fase)
      .then(() => {
        toastContext.success(
          'Fase ' + (paramId ? 'aggiornata' : 'aggiunta') + ' con successo!',
          4000
        );
        statusContext.removeEvent('onbeforeunload');

        setTimeout(() => {
          navigation(`/gestione-fasi`);
        }, 100);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
      });
  };

  return (
    <div className='rtds-container rtds-my-12'>
      <div className='rtds-mb-6'>
        <h1 className='rtds-text-2xl rtds-font-bold'>
          {paramId ? 'Modifica Fase' : 'Inserisci Fase'}
        </h1>
      </div>
      <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
        <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className='rtds-font-bold rtds-no-underline'
              title='obbligatorio'
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id='hasValidationForm'
          className='has-js-validation-form rtds-py-6 rtds-space-y-4'
          onSubmit={sendData}
        >
          <Input
            label={'Titolo'}
            required
            id={'titolo'}
            inputErrors={inputErrors}
            classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
            type={'text'}
            onChange={(event) => onChangeValue(event)}
            value={fase.titolo || ''}
            maxLength={50}
            disabled={paramId}
          />
          <Select
            classDiv={'rtds-mt-3 lg:rtds-mt-0'}
            label={'Avviso'}
            required
            id={'avviso'}
            inputErrors={inputErrors}
            classSelect={''}
            onChange={(event) => onChangeBando(event)}
            baseOption={'Seleziona Avviso'}
            bindKey={'id'}
            bindValue={'nome'}
            options={bandi}
            value={fase.bando?.id || fase.bando_id || ''}
            disabled={!!paramId}
          />

          {fase.bando && (
            <>
              <div className='rtds-field-row'>
                <Select
                  classDiv={'rtds-mt-3 lg:rtds-mt-0'}
                  label={'Tipologia'}
                  required
                  id={'tipologia'}
                  inputErrors={inputErrors}
                  classSelect={''}
                  onChange={(event) => onChangeTipologia(event)}
                  baseOption={'Seleziona Tipologia'}
                  options={tipologie}
                  value={fase.tipologia || ''}
                  disabled={!!paramId}
                />
                <Select
                  classDiv={'rtds-mt-3 lg:rtds-mt-0'}
                  label={'Fase associata'}
                  required={associablePresentazioneDomande}
                  id={'raccoltaDomande'}
                  inputErrors={inputErrors}
                  classSelect={''}
                  onChange={(event) => onChangeValue(event)}
                  baseOption={'Seleziona Fase Presentazione Domande'}
                  options={fasiPresentazioneDomande}
                  value={fase.raccoltaDomande?.id || fase.raccoltaDomande || ''}
                  bindValue={'titolo'}
                  bindKey={'id'}
                  hidden={
                    fasiPresentazioneDomande.length === 0 ||
                    !associablePresentazioneDomande
                  }
                />
                {
                  associablePresentazioneDomande &&
                  fasiPresentazioneDomande.length === 0 && (
                    <div className='rtds-input-field rtds-select-field rtds-gap-1 rtds-mt-3 lg:rtds-mt-0'>
                      <p className='rtds-input-field__label undefined'>Fase associata</p>
                      <p className='rtds-bg-warn-light rtds-content-center rtds-rounded-lg rtds-p-1.5' >
                        <svg
                          className='rtds-icon rtds-fill-current rtds-w-8 rtds-h-8'
                          aria-hidden='true'
                          focusable='false'
                          role='img'
                        >
                          <use
                            xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#outline--exclamation-triangle`}
                          />
                        </svg>
                        &nbsp;Non ci sono fasi di tipo <strong>'Presentazione domande'</strong> disponibili
                        per questo avviso.
                      </p>
                    </div>
                  )
                }
              </div>

              <fieldset
                className='rtds-input-field rtds-input-fieldset'
                hidden={!fase.tipologia}
              >
                <legend className='rtds-input-field__label'>
                  Date
                  <abbr
                    className='rtds-font-bold rtds-no-underline'
                    title='obbligatorio'
                  >
                    *
                  </abbr>
                </legend>
                <div className='rtds-grid sm:rtds-flex rtds-gap-4 sm:rtds-gap-6 sm:rtds-items-start'>
                  <DatePicker
                    required
                    label={'Data Inizio'}
                    id={'dataInizio'}
                    inputErrors={inputErrors}
                    classInput={'rtds-text-sm rtds-input-placeholder'}
                    type={'datetime-local'}
                    onInput={(event) =>
                      updateMapDate(event)
                    }
                    min={
                      fase.dataInizio && fase.dataInizio < now ? fase.dataInizio : now
                    }
                    max={
                      "9999-12-31 23:59"
                    }
                    defaultValue={
                      fase.dataInizio
                        ? moment(fase.dataInizio).format('YYYY-MM-DD HH:mm')
                        : ''
                    }
                    errorMessage={checkValidaDateError(
                      'dataInizio',
                      [now],
                      [],
                      [now]
                    )}
                  />

                  <DatePicker
                    required
                    label={
                      'Data Fine'
                    }
                    id={
                      'dataFine'
                    }
                    inputErrors={inputErrors}
                    classInput={'rtds-text-sm rtds-input-placeholder'}
                    type={'datetime-local'}
                    onInput={(event) =>
                      updateMapDate(event)
                    }
                    min={
                      mapDate.get('dataInizio')
                    }
                    max="9999-12-31T23:59"
                    defaultValue={
                      fase.dataFine
                        ? moment(fase.dataFine).format('YYYY-MM-DD HH:mm')
                        : ''
                    }
                    errorMessage={
                      checkValidaDateError('dataFine', ['dataInizio'], [])
                    }
                  />
                </div>
              </fieldset>
            </>
          )}

          <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
            <div className='rtds-form-actions'>
              <div
                className='rtds-inline-flex rtds-gap-1'
                role='group'
                aria-label='Azioni'
              >
                <button
                  type='button'
                  className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  onClick={() => denyOperation()}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6  group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>{' '}
                  Annulla
                </button>
                <button
                  type='submit'
                  className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button'
                >
                  {/*<svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                        paramId
                          ? 'solid--pencil-square '
                          : 'solid--plus-circle'
                      }`}
                    />
                  </svg>*/}
                  {paramId ? 'Salva' : 'Salva'}
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                        paramId
                          ? 'solid--chevron-right'
                          : 'solid--chevron-right'
                      }`}
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
